import { Skull, UsersRound } from "lucide-react";

import { useModalFocus } from "../lib/useModalFocus";
import type { GameState } from "../types";
import { SurvivorPortrait } from "./SurvivorPortrait";

export function CommunityEndedDialog({ state, onReturnToTitle }: { state: GameState; onReturnToTitle: () => void }) {
  const modalRef = useModalFocus<HTMLDivElement>({ focusKey: `ended-${state.site.number}` });
  const lost = state.survivors.filter((survivor) => !survivor.alive);

  return (
    <div
      ref={modalRef}
      className="modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="community-ended-title"
      aria-describedby="community-ended-description"
      tabIndex={-1}
    >
      <section className="battle-report report-overrun community-ended-dialog">
        <Skull className="report-icon" aria-hidden="true" />
        <span className="eyebrow danger">Community record closed</span>
        <h2 id="community-ended-title">The last light has gone out.</h2>
        <p id="community-ended-description">No one escaped {state.site.name}. This community's story ends here, but its record remains.</p>
        <div className="community-ended-count"><UsersRound aria-hidden="true" /><strong>{lost.length}</strong><span>lives remembered</span></div>
        {lost.length > 0 && <div className="report-loss-list">{lost.map((survivor) => <span className="report-loss-person" key={survivor.id}><SurvivorPortrait survivor={survivor} detail="thumb" /><b>{survivor.name}</b></span>)}</div>}
        <button className="primary-button" onClick={onReturnToTitle}>Return to the title screen</button>
      </section>
    </div>
  );
}
